import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import CoursesSection from './CoursesSection';
import TrialCourseCard from '../ProgramsCard/TrialCourseCard';

const TrialCoursesBlock = ({ title, courses, initiallyOpen }) => {
  const navigate = useNavigate();

  const getAccounts = (productId, type) => {
    localStorage.setItem('product_id', JSON.stringify(productId));
    localStorage.setItem('type', JSON.stringify(type));
    navigate('/finance/accounts');
  };

  return (
    <CoursesSection title={title} initiallyOpen={initiallyOpen}>
      {courses.map((course) => (
        <TrialCourseCard key={course.id} course={course} getAccounts={getAccounts} />
      ))}
    </CoursesSection>
  );
};

TrialCoursesBlock.propTypes = {
  courses: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  initiallyOpen: PropTypes.bool,
};

TrialCoursesBlock.defaultProps = {
  initiallyOpen: true,
};

export default TrialCoursesBlock;
